import { Component, inject } from '@angular/core';
import { MandantConfigService } from '@strategies/mandant-config.service';

@Component({
  selector: 'app-layout-container-colored-backgroundimage',
  templateUrl: '../../_base/layout/layout-container.component.html',
  standalone: false,
})
export class LayoutContainerColoredBackgroundimageComponent {
  private mandantService = inject(MandantConfigService);

  public imageUrl: any = this.mandantService.mandant.backgroundUrl;

  public applyColoringToBg = true;
}
